export default __webpack_public_path__ + "static/team-working-cactus-mural@2x-40d86f54f0eb7ef60d39740332c50849.webp";